export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const PRODUCTS_URL = process.env.REACT_APP_PRODUCTS_URL;
export const USERS_URL = process.env.REACT_APP_USERS_URL;
export const ORDERS_URL = process.env.REACT_APP_ORDERS_URL;
export const PAYMENT_GATEWAY_URL = process.env.REACT_APP_PAYMENT_GATEWAY_URL;
